export const UPDATE_SETTING_BY_KEY = 'SETTINGS/UPDATE_SETTING_BY_KEY';
